import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Wizard from 'components/Forms/Wizard/Wizard';

const UpdateIncomplete = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const application = location?.state?.application || null;

  useEffect(() => {
    if (!application) {
      navigate('/applications');
    }
  }, [application, navigate]);

  if (!application) return null;

  return (
    <Wizard MODE="APPLICATION_INCOMPLETE" initialData={application} />
  );
};

export default UpdateIncomplete;


